import axios from "@/api/axiosInstance";
import {
  FetchMyTransactionHistoryParams,
  FetchMyTransactionHistoryResponse,
} from "./types";

export const fetchMyTransactionHistory = async (
  params: FetchMyTransactionHistoryParams = {},
  signal?: AbortSignal,
): Promise<FetchMyTransactionHistoryResponse> => {
  const response = await axios.get<FetchMyTransactionHistoryResponse>(
    "/api/private/my/transaction-history",
    { params, signal },
  );
  return response.data;
};
